var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFlyingLanding(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.5 4.06033V6.64575C0.5 6.87543 0.656476 7.07557 0.87937 7.13098L6.11629 8.43289L12.6193 10.0578C13.3898 10.2503 14.474 10.188 14.4995 9.39419C14.504 9.25462 14.4788 9.117 14.4321 8.98791C14.2484 8.48085 13.6743 8.28462 13.1543 8.14157L9.94679 7.25918C9.78443 7.21451 9.65546 7.09112 9.60366 6.93089L7.68554 0.997526C7.63268 0.834002 7.49954 0.709087 7.33298 0.666743L6.73949 0.515859C6.42344 0.435508 6.11629 0.674336 6.11629 1.00044V5.64309C6.11629 5.9679 5.81144 6.20649 5.49615 6.12844L2.55529 5.40045C2.39839 5.36161 2.26994 5.24932 2.21048 5.09902L1.75682 3.95216C1.6981 3.80369 1.572 3.6922 1.41747 3.6521L1.12559 3.57636C0.808947 3.49419 0.5 3.7332 0.5 4.06033Z",
    fill: "#FFFFFE",
    stroke: "#FFFFFE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0.5 15.3574H15.5",
    stroke: "#FFFFFE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlyingLanding);
export default __webpack_public_path__ + "static/media/flying-landing.c76bf0c4c4ab82ba5430d58b078b7212.svg";
export { ForwardRef as ReactComponent };